import {Injectable} from '@angular/core';
import {Disclaimer} from '../../../models/disclaimer';

@Injectable({
  providedIn: 'root'
})
export class PrivacyStore {

  disclaimers: Disclaimer[];

  constructor() {
    this.disclaimers = [];
  }

}
